/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, createContext, PropsWithChildren, useEffect } from "react";
import type { Product as IProduct } from "~api/stream/interfaces";

interface IRealtimeProductsContext {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  selectedProducts: IProduct[];
  setSelectedProducts: (value: IProduct[]) => void;
  productList: IProduct[];
  setProductList: (value: IProduct[]) => void;
}

const RealtimeProductsContext = createContext<IRealtimeProductsContext>({
  searchTerm: "",
  setSearchTerm: () => "",
  selectedProducts: [],
  setSelectedProducts: () => [],
  productList: [],
  setProductList: () => [],
});

export const RealtimeProductsContextProvider = ({ children }: PropsWithChildren) => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [selectedProducts, setSelectedProducts] = useState<IProduct[]>([]);
  const [productList, setProductList] = useState<IProduct[]>([]);

  useEffect(() => {
    const productIds = selectedProducts.map((selected) => selected.id);
    const updatedProductList = productList.map((product) => {
      return { ...product, isChecked: productIds.includes(product.id) };
    });
    setProductList(updatedProductList);
  }, [selectedProducts]);

  return (
    <RealtimeProductsContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        selectedProducts,
        setSelectedProducts,
        productList,
        setProductList,
      }}
    >
      {children}
    </RealtimeProductsContext.Provider>
  );
};

export const useRealtimeProductsContext = () => {
  const context = useContext(RealtimeProductsContext);
  return context;
};
